import IconItem from '@ifca-root/react-component/src/components/Avatar/IconItem'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import ConsolidateIcon from 'assets/einvoice/einvoice-consolidate.svg'
import Advance from 'assets/icons/ARAPModule/AccountPayable/advances-posting.svg'
import CreditNote from 'assets/icons/ARAPModule/AccountPayable/credit-note-posting.svg'
import DebitNote from 'assets/icons/ARAPModule/AccountPayable/Group 64855.svg'
import Invoices from 'assets/icons/ARAPModule/AccountPayable/invoices-posting.svg'
import Payment from 'assets/icons/ARAPModule/AccountPayable/payment-posting.svg'
import Refund from 'assets/icons/ARAPModule/AccountPayable/refund-posting.svg'
import DebtorProfile from 'assets/icons/ARAPModule/GeneralSetting/creditor-profile.svg'
import ScheduledBilling from 'assets/icons/ARAPModule/AccountReceivable/scheduled-billing.svg'
import ProformaInvoices from 'assets/icons/ARAPModule/AccountReceivable/proforma-invoices.svg'
import Debtor from 'assets/icons/ARAPModule/debtor-creditor-acc.svg'
import Amortisation from 'assets/icons/ARAPModule/Invoice Amortisation.svg'
import DigitalReports from 'assets/icons/digital-reporting.svg'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { SwitchDialog } from 'components/Switch/SwitchDialog'
import AppContext from 'containers/App/Store/AppContext'
import {
  AcctPermission,
  RecordStatus,
  useGetArScheduledBillingSummaryLazyQuery,
  useGetArSubmenuSummaryLazyQuery,
  useGetAssignedCompanyQuery,
  useGetCompanyNameQuery,
  useGetCompanyForScheduledBillingLazyQuery,
  useGetDebtorSubmenuSummaryLazyQuery,
  useGetDebtorTrxSummaryLazyQuery,
  useGetDebtorAccountLazyQuery,
  useGetDebtorCountQuery,
} from 'generated/graphql'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import { getProductShortName } from 'utils/logoConfig'

export const ARSubmenu = (props: any) => {
  const { globalState, dispatch }: any = useContext(AppContext as any)
  let history = useHistory()
  const { CompanyID, DebtorAccountID }: any = useParams()

  const [change, setSwitch] = useState(false)
  const [homeCompanyID, setHomeCompanyID] = useState<string>(CompanyID)

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const scheduledBillingEnv = !![
    'local',
    'azure',
    'internal',
    'axifcadev',
  ].includes(process.env.REACT_APP_LOCAL_DB)
  const productShortName = getProductShortName()

  if (globalState?.mode === '') {
    dispatch({
      type: 'mode',
      payload: 'general-ledger',
    })
  }

  useEffect(() => {
    document.title = `${productShortName} - Acc Receivable`
  }, [])

  useEffect(() => {
    localStorage.removeItem(`searchFilter`)
  }, [])

  // LocalStorage for lastAccessedModule
  localStorage.setItem('lastAccessedModule', 'ACCOUNT_RECEIVABLE')

  // ACCOUNTX API CALLS
  const {
    loading: CompanyLoading,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID, RecordStatus: RecordStatus.Active },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      if (
        ['local', 'azure', 'internal', 'axifcadev'].includes(
          process.env.REACT_APP_LOCAL_DB
        )
      ) {
        loadScheduledBillingIsProforma({
          variables: { CompanyID },
        })
      }
    },
  })

  // getCompanyLazyQuery for ARSubmenu
  const [
    loadScheduledBillingIsProforma,
    {
      loading: ScheduledBillingControlLoading,
      data: { getCompany: getCompanyForScheduledBilling } = { getCompany: [] },
    },
  ] = useGetCompanyForScheduledBillingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  //Debtor Account Company Assignment//

  const [
    loadDebtorAccount,
    {
      loading: DebtorAccountLoading,
      data: { getDebtorAccount } = {
        getDebtorAccount: [],
      },
    },
  ] = useGetDebtorAccountLazyQuery({
    fetchPolicy: 'network-only',
    variables: { DebtorAccountID: DebtorAccountID, CompanyID: CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: CompanyAssignedLoading,
    data: { getAssignedCompanyByUser } = { getAssignedCompanyByUser: [] },
  } = useGetAssignedCompanyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: getDebtorCountLoading,
    data: { getDebtorCount } = { getDebtorCount: [] },
  } = useGetDebtorCountQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    loadARSubmenuSummary,
    {
      loading: ARSubmenuSummaryLoading,
      data: {
        arAdvanceCount,
        arInvoiceCount,
        arCreditNoteCount,
        arDebitNoteCount,
        arOfficialReceiptCount,
        arRefundCount,
        getDocToConsolidateCount,
      } = {
        arAdvanceCount: 0,
        arInvoiceCount: 0,
        arCreditNoteCount: 0,
        arDebitNoteCount: 0,
        arOfficialReceiptCount: 0,
        arRefundCount: 0,
      },
    },
  ] = useGetArSubmenuSummaryLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
      if (
        !CompanyID ||
        CompanyID === 'undefined' ||
        CompanyID === 'null' ||
        CompanyID === ''
      ) {
        setErrDialog(true)
        setErrMessage('Please select company before continue.')
        return
      }
    },
  })

  const [
    loadARScheduledBillingSummary,
    {
      loading: ARScheduledBillingSummaryLoading,
      data: {
        arScheduledBillingCount,
        arSalesOrderBillingScheduleCount,
        arGenerateScheduledBillingCount,
        arProformaInvoicesCount,
        arProformaInvoiceRequisitionCount,
        arIssueProformaInvoiceCount,
        arIssueActualInvoiceCount,
        arAmortisationCount,
      } = {
        arSalesOrderBillingScheduleCount: 0,
        arScheduledBillingCount: [],
        arGenerateScheduledBillingCount: [],
        arProformaInvoicesCount: [],
        arProformaInvoiceRequisitionCount: 0,
        arIssueProformaInvoiceCount: 0,
        arIssueActualInvoiceCount: 0,
        arAmortisationCount: 0,
      },
    },
  ] = useGetArScheduledBillingSummaryLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      if (scheduledBillingEnv) {
        let error = message?.substring(15)
        setErrMessage(error)
        setErrDialog(true)
      }
    },
  })

  const [
    loadDebtorSubmenuSummary,
    {
      loading: DebtorSubmenuSummaryLoading,
      data: {
        arAdvanceTotalAmt,
        arInvoiceTotalAmt,
        arCreditNoteTotalAmt,
        arDebitNoteTotalAmt,
        arOfficialReceiptTotalAmt,
        arRefundTotalAmt,
      } = {
        arAdvanceTotalAmt: 0,
        arInvoiceTotalAmt: 0,
        arCreditNoteTotalAmt: 0,
        arDebitNoteTotalAmt: 0,
        arOfficialReceiptTotalAmt: 0,
        arRefundTotalAmt: 0,
      },
    },
  ] = useGetDebtorSubmenuSummaryLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const DebtorAccountTotalAmount =
    arInvoiceTotalAmt?.total +
    arDebitNoteTotalAmt?.total -
    arCreditNoteTotalAmt?.total -
    arOfficialReceiptTotalAmt?.total +
    arRefundTotalAmt?.total -
    arAdvanceTotalAmt?.total

  const [
    loadDebtorTrxSummary,
    {
      loading: DebtorTrxSummaryLoading,
      data: {
        arAdvanceLatestUpdate,
        arInvoiceLatestUpdate,
        arCreditNoteLatestUpdate,
        arDebitNoteLatestUpdate,
        arOfficialReceiptLatestUpdate,
        arRefundLatestUpdate,
      } = {
        arAdvanceLatestUpdate: undefined,
        arInvoiceLatestUpdate: undefined,
        arCreditNoteLatestUpdate: undefined,
        arDebitNoteLatestUpdate: undefined,
        arOfficialReceiptLatestUpdate: undefined,
        arRefundLatestUpdate: undefined,
      },
    },
  ] = useGetDebtorTrxSummaryLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  useEffect(() => {
    if (DebtorAccountID) {
      loadDebtorAccount()
      loadDebtorSubmenuSummary({
        variables: {
          CompanyID: CompanyID,
          DebtorAccountID: DebtorAccountID,
        },
      })
      loadDebtorTrxSummary({
        variables: {
          CompanyID: CompanyID,
          DebtorAccountID: DebtorAccountID,
        },
      })
    } else {
      loadARSubmenuSummary({
        variables: { CompanyID: CompanyID },
      })
      scheduledBillingEnv &&
        loadARScheduledBillingSummary({
          variables: { CompanyID },
        })
    }
  }, [DebtorAccountID, CompanyID])

  const { handlePermHidden } = usePermissionChecker()

  /* -------------------------------------------- */
  /*                  AR SUBMENU                  */
  /* -------------------------------------------- */
  const debtorAcc = {
    path: `/account-receivable/${CompanyID}/debtor-account`,
    icon: Debtor,
    title: `Debtor Accounts`,
    code: `DA`,
    label1: `${getDebtorCount || 0} Debtor`,
    permission: AcctPermission.AccReceivableDebtorAccView,
    deployed: true,
  }

  // Scheduled Billing
  const saleOrderBillingScheduled = {
    title: 'Sales Order Billing Schedule',
    path: `/account-receivable/${CompanyID}/scheduled-billing/sales-order`,
    dataLabelArray: [
      { data: arSalesOrderBillingScheduleCount?.draft, label: 'Draft' },
      { data: arSalesOrderBillingScheduleCount?.submitted, label: 'Completed' },
    ],
    // icon: Debtor,
    code: 'SOBS',
    permission: AcctPermission.AccReceivableSalesOrderBillingScheduleView,
    deployed:
      process.env.REACT_APP_LOCAL_DB === 'local' ||
      process.env.REACT_APP_LOCAL_DB === 'internal' ||
      process.env.REACT_APP_LOCAL_DB === 'azure' ||
      process.env.REACT_APP_LOCAL_DB === 'axifcadev'
        ? true
        : false,
  }

  const generateScheduledBilling = {
    title: 'Generate Schedule Billing',
    path: `/account-receivable/${CompanyID}/scheduled-billing/generate-scheduled-billing`,
    dataLabelArray: [
      {
        data: arGenerateScheduledBillingCount?.scheduledBilling ?? '0',
        label: 'Schedule',
      },
      {
        data: arGenerateScheduledBillingCount?.Billed ?? '0',
        label: 'Billed',
      },
    ],
    // icon: Debtor,
    code: 'GSB',
    permission: AcctPermission.AccReceivableGenerateScheduledBillingView,
    deployed:
      process.env.REACT_APP_LOCAL_DB === 'local' ||
      process.env.REACT_APP_LOCAL_DB === 'internal' ||
      process.env.REACT_APP_LOCAL_DB === 'azure' ||
      process.env.REACT_APP_LOCAL_DB === 'axifcadev'
        ? true
        : false,
  }
  const scheduledBilling = {
    path: '', // No direct navigation
    icon: ScheduledBilling,
    title: 'Schedule Billing',
    code: 'SB',
    permission: AcctPermission.AccReceivableScheduledBillingView,
    deployed:
      process.env.REACT_APP_LOCAL_DB === 'local' ||
      process.env.REACT_APP_LOCAL_DB === 'internal' ||
      process.env.REACT_APP_LOCAL_DB === 'azure' ||
      process.env.REACT_APP_LOCAL_DB === 'axifcadev'
        ? true
        : false,
    expandItems: [saleOrderBillingScheduled, generateScheduledBilling],
  }

  // Proforma Invoices ======= Please change all the permissions - AQIL
  const proformaExpandItems = [
    {
      title: 'Proforma Invoice Requisition',
      path: `/account-receivable/${CompanyID}/proforma-invoices/proforma-invoice-requisition`,
      dataLabelArray: [
        { data: arProformaInvoiceRequisitionCount?.draft, label: 'Draft' },
        {
          data: arProformaInvoiceRequisitionCount?.submitted,
          label: 'Submitted',
        },
      ],
      // icon: Debtor,
      code: 'PIR',
      permission: AcctPermission.AccReceivableProformaInvoiceRequisitionView, // change
      deployed:
        process.env.REACT_APP_LOCAL_DB === 'local' ||
        process.env.REACT_APP_LOCAL_DB === 'internal' ||
        process.env.REACT_APP_LOCAL_DB === 'azure' ||
        process.env.REACT_APP_LOCAL_DB === 'axifcadev'
          ? true
          : false,
    },
    {
      title: 'Issue Proforma Invoice',
      path: `/account-receivable/${CompanyID}/proforma-invoices/issue-proforma-invoice`,
      dataLabelArray: [
        { data: arIssueProformaInvoiceCount?.pending, label: 'Pending' },
        { data: arIssueProformaInvoiceCount?.issued, label: 'Issued' },
      ],
      // icon: Debtor,
      code: 'IPI',
      permission: AcctPermission.AccReceivableIssueProformaInvoiceView, // change
      deployed:
        process.env.REACT_APP_LOCAL_DB === 'local' ||
        process.env.REACT_APP_LOCAL_DB === 'internal' ||
        process.env.REACT_APP_LOCAL_DB === 'azure' ||
        process.env.REACT_APP_LOCAL_DB === 'axifcadev'
          ? true
          : false,
    },
    {
      title: 'Issue Actual Invoice',
      path: `/account-receivable/${CompanyID}/proforma-invoices/issue-actual-invoice`,
      dataLabelArray: [
        { data: arIssueActualInvoiceCount?.pending, label: 'Pending' },
      ],
      // icon: Debtor,
      code: 'IAI',
      permission: AcctPermission.AccReceivableIssueActualInvoiceView, // change
      deployed:
        process.env.REACT_APP_LOCAL_DB === 'local' ||
        process.env.REACT_APP_LOCAL_DB === 'internal' ||
        process.env.REACT_APP_LOCAL_DB === 'azure' ||
        process.env.REACT_APP_LOCAL_DB === 'axifcadev'
          ? true
          : false,
    },
  ]
  const proformaInvoices = {
    path: '', // No direct navigation
    icon: ProformaInvoices,
    title: 'Proforma Invoices',
    code: 'PI',
    label1: '4 Jan 3 Feb 2 Mar',
    data1: 0,
    permission: AcctPermission.AccReceivableProformaInvoicesView,
    deployed:
      process.env.REACT_APP_LOCAL_DB === 'local' ||
      process.env.REACT_APP_LOCAL_DB === 'internal' ||
      process.env.REACT_APP_LOCAL_DB === 'azure' ||
      process.env.REACT_APP_LOCAL_DB === 'axifcadev'
        ? true
        : false,
    expandItems: proformaExpandItems,
  }

  const advance = {
    path: `/account-receivable/${CompanyID}/advance`,
    icon: Advance,
    title: `Advances`,
    draft: arAdvanceCount?.draft,
    submitted: arAdvanceCount?.submitted,
    code: `AV`,
    permission: AcctPermission.AccReceivableAdvancesView,
    deployed: true,
  }

  const officialReceipt = {
    path: `/account-receivable/${CompanyID}/official-receipt`,
    icon: Advance,
    title: `Official Receipts`,
    draft: arOfficialReceiptCount?.draft,
    submitted: arOfficialReceiptCount?.submitted,
    code: `OR`,
    permission: AcctPermission.AccReceivableReceiptsView,
    deployed: true,
  }

  const invoice = {
    path: `/account-receivable/${CompanyID}/invoice`,
    icon: Invoices,
    title: `Invoices`,
    draft: arInvoiceCount?.draft,
    submitted: arInvoiceCount?.submitted,
    code: `IV`,
    permission: AcctPermission.AccReceivableInvoicesView,
    deployed: true,
  }

  const invoiceAmortisation = {
    path: `/account-receivable/${CompanyID}/invoice-amortisation`,
    icon: Amortisation,
    title: `Invoice Amortisation`,
    draft: arAmortisationCount?.draft,
    submitted: arAmortisationCount?.submitted,
    code: `IA`,
    permission: AcctPermission.AccReceivableInvoiceAmortisationView,
    deployed:
      process.env.REACT_APP_LOCAL_DB === 'local' ||
      process.env.REACT_APP_LOCAL_DB === 'internal' ||
      process.env.REACT_APP_LOCAL_DB === 'azure' ||
      process.env.REACT_APP_LOCAL_DB === 'axifcadev'
        ? true
        : false,
  }

  const creditNote = {
    path: `/account-receivable/${CompanyID}/credit-note`,
    icon: CreditNote,
    title: `Credit Notes`,
    draft: arCreditNoteCount?.draft,
    submitted: arCreditNoteCount?.submitted,
    code: `CN`,
    permission: AcctPermission.AccReceivableCreditNotesView,
    deployed: true,
    // disabled: true,
  }

  const debitNote = {
    path: `/account-receivable/${CompanyID}/debit-note`,
    icon: DebitNote,
    title: `Debit Notes`,
    draft: arDebitNoteCount?.draft,
    submitted: arDebitNoteCount?.submitted,
    code: `DN`,
    permission: AcctPermission.AccReceivableDebitNotesView,
    deployed: true,
  }

  const refund = {
    path: `/account-receivable/${CompanyID}/refund`,
    icon: Refund,
    title: `Refunds`,
    draft: arRefundCount?.draft,
    submitted: arRefundCount?.submitted,
    code: `RF`,
    permission: AcctPermission.AccReceivableRefundView,
    deployed: true,
  }

  const glExport = {
    path: `/account-receivable/${CompanyID}/gl-export`,
    icon: DigitalReports,
    title: `GL Export`,
    label1: ` `,
    data1: ' ', //hardcode
    deployed: true,
    disabled: true,
    // permission:
  }

  const consolidatedEInvoice = {
    path: `/account-receivable/${CompanyID}/consolidate-einvoice`,
    icon: ConsolidateIcon,
    title: `Consolidate e-Invoice`,
    label1: `${getDocToConsolidateCount} pending to Consolidate`,
    permission: AcctPermission.AccReceivableConsolidateEinvoiceView,
    deployed: true,
  }

  /* -------------------------------------------- */
  /*           DEBTOR ACCOUNT SUBMENU           */
  /* -------------------------------------------- */
  const debtorProfile = {
    path: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/detail`,
    icon: DebtorProfile,
    title: `Debtor Profile`,
    title2: ``,
    label1: `Last updated on `,
    deployed: true,
    data1: `${formatDate(
      getDebtorAccount[0]?.modTs ?? getDebtorAccount[0]?.createdTs
    )}.`,
    permission: AcctPermission.AccReceivableDebtorAccView,
  }

  const debtorInvoice = {
    path: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/invoice`,
    icon: Invoices,
    title: `Invoices`,
    title2: arInvoiceTotalAmt?.total,
    label1: `Last invoice date on `,
    deployed: true,
    data1: `${formatDate(arInvoiceLatestUpdate?.latestUpdate)}.`,
    permission: AcctPermission.AccReceivableInvoicesView,
  }

  const debtorCreditNote = {
    path: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/credit-note`,
    icon: CreditNote,
    title: `Credit Note`,
    title2: arCreditNoteTotalAmt?.total,
    label1: `Last credit note date on `,
    deployed: true,
    data1: `${formatDate(arCreditNoteLatestUpdate?.latestUpdate)}.`,
    permission: AcctPermission.AccReceivableCreditNotesView,
  }

  const debtorDebitNote = {
    path: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/debit-note`,
    icon: DebitNote,
    title: `Debit Note`,
    title2: arDebitNoteTotalAmt?.total,
    label1: `Last debit note date on `,
    deployed: true,
    data1: `${formatDate(arDebitNoteLatestUpdate?.latestUpdate)}.`,
    permission: AcctPermission.AccReceivableDebitNotesView,
  }

  const debtorAdvance = {
    path: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/advance`,
    icon: Advance,
    title: `Advances`,
    title2: arAdvanceTotalAmt?.total,
    label1: `Last advance date on `,
    deployed: true,
    data1: `${formatDate(arAdvanceLatestUpdate?.latestUpdate)}.`,
    permission: AcctPermission.AccReceivableAdvancesView,
  }

  const debtorReceipt = {
    path: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/official-receipt`,
    icon: Payment,
    title: `Official Receipts`,
    title2: arOfficialReceiptTotalAmt?.total,
    label1: `Last official receipt date on `,
    deployed: true,
    data1: `${formatDate(arOfficialReceiptLatestUpdate?.latestUpdate)}.`,
    permission: AcctPermission.AccReceivableReceiptsView,
  }

  const debtorRefund = {
    path: `/account-receivable/${CompanyID}/debtor-account/debtor-profile/${DebtorAccountID}/refund`,
    icon: Refund,
    title: `Refund`,
    title2: arRefundTotalAmt?.total,
    label1: `Last refund date on `,
    deployed: true,
    data1: `${formatDate(arRefundLatestUpdate?.latestUpdate)}.`,
    permission: AcctPermission.AccReceivableRefundView,
  }

  let mainMenuList = [],
    headerTitle,
    RETURN_ROUTES

  if (!DebtorAccountID) {
    mainMenuList = [
      debtorAcc,
      ['local', 'azure', 'internal', 'axifcadev'].includes(
        process.env.REACT_APP_LOCAL_DB
      ) && scheduledBilling,
      ['local', 'azure', 'internal', 'axifcadev'].includes(
        process.env.REACT_APP_LOCAL_DB
      ) &&
        getCompanyForScheduledBilling[0]?.isProforma!! &&
        proformaInvoices,
      invoice,
      invoiceAmortisation,
      creditNote,
      debitNote,
      advance,
      officialReceipt,
      refund,
      getCompany[0]?.eInvIntegrated!! ? consolidatedEInvoice : null,
      // glExport,
    ]
    headerTitle = 'Account Receivable'
    RETURN_ROUTES = `/account-receivable/${CompanyID}`
  } else {
    mainMenuList = [
      debtorProfile,
      debtorInvoice,
      debtorCreditNote,
      debtorDebitNote,
      debtorAdvance,
      debtorReceipt,
      debtorRefund,
    ]
    headerTitle = 'Account Receivable'
    RETURN_ROUTES = `/account-receivable/${CompanyID}/debtor-account`
  }

  const totalDebtorDocAmt = getDebtorAccount?.reduce(
    (previousValue, currentValue) => previousValue + currentValue?.TotalAmt,
    0
  )

  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  let userAccDetail = {
    ...user,
    companyID: getCompany[0]?.CompanyID,
    companyName: getCompany[0]?.Name,
  }

  localStorage.setItem('loggedInUser', JSON.stringify(userAccDetail))

  return (
    <>
      {CompanyLoading && <Loading />}
      {DebtorAccountLoading && <Loading />}
      {getDebtorCountLoading && <Loading />}
      {CompanyAssignedLoading && <Loading />}
      {DebtorTrxSummaryLoading && <Loading />}
      {ARSubmenuSummaryLoading && <Loading />}
      {DebtorSubmenuSummaryLoading && <Loading />}
      {ScheduledBillingControlLoading && <Loading />}
      {ARScheduledBillingSummaryLoading && <Loading />}
      <MainHeader
        mainBtn={'back'}
        onClick={
          DebtorAccountID
            ? () =>
                history.push(`/account-receivable/${CompanyID}/debtor-account`)
            : () => history.push(`/`)
        }
        smTitle={`${headerTitle}`}
        title={getCompany[0]?.Name}
        onClickAction={() => setSwitch(true)}
        sideBtn="company"
        rightCustomIcon={getCompany[0]?.Logo?.fileURL}
        routeSegments={
          DebtorAccountID
            ? [
                { name: 'AR' },
                { name: 'Main Menu' },
                { name: 'Debtor Account', current: true },
              ]
            : [{ name: 'Main Menu', current: true }]
        }
      />

      {DebtorAccountID ? (
        <DynamicSubHeader
          title={
            <span>
              <span style={{ fontWeight: 'bold' }}>
                {getDebtorAccount[0]?.DebtorName}
              </span>
            </span>
          }
          rightText={
            <>
              <span>
                <>
                  <span className="c-orange ">
                    {DebtorAccountTotalAmount < 0
                      ? `(${amtStr(DebtorAccountTotalAmount * -1)})`
                      : amtStr(DebtorAccountTotalAmount)}
                  </span>
                </>
              </span>
            </>
          }
        />
      ) : null}

      <ContentWrapper
        footer={!!DebtorAccountID}
        singleDynamicInfo={!!DebtorAccountID}
      >
        <List className="core-list">
          {mainMenuList
            .filter(el => el != null)
            .map((el, index) => {
              // Check if the item has expandable items
              if (el?.expandItems) {
                if (!handlePermHidden({ permEnum: el?.permission })) {
                  return null
                }
                return (
                  <CardExpansion
                    key={index}
                    summary={
                      <ListItem>
                        <IconItem
                          image={el?.icon}
                          imageType="svg"
                          badgeType="default"
                        />
                        <ListItemText
                          style={{ marginLeft: '4px' }}
                          primary={<span className="xsTitle">{el?.title}</span>}
                          secondary={
                            el?.code === 'SB' ? (
                              arScheduledBillingCount?.map(x => {
                                return (
                                  <span className="desc">
                                    <span className="text c-orange">
                                      {x?.Count}&nbsp;
                                    </span>
                                    <span className="text">
                                      {x?.Month}&nbsp;&nbsp;{' '}
                                    </span>
                                  </span>
                                )
                              })
                            ) : el?.code === 'PI' ? (
                              arProformaInvoicesCount?.map(x => {
                                return (
                                  <span className="desc">
                                    <span className="text c-orange">
                                      {x?.Count}&nbsp;
                                    </span>
                                    <span className="text">
                                      {x?.Month}&nbsp;&nbsp;{' '}
                                    </span>
                                  </span>
                                )
                              })
                            ) : (
                              <span className="desc">
                                <span className="text c-orange">
                                  {el?.data1}
                                </span>
                              </span>
                            )
                          }
                        />
                      </ListItem>
                    }
                  >
                    <List className="core-list" style={{ width: '100%' }}>
                      {el.expandItems.map((expandItem, expandIndex) => (
                        <ListItem
                          key={expandIndex}
                          onClick={() => history.push(expandItem.path)}
                        >
                          {expandItem?.icon && (
                            <IconItem
                              image={expandItem?.icon}
                              imageType="svg"
                              badgeType="default"
                            />
                          )}
                          <ListItemText
                            primary={
                              <span className="xsTitle">
                                {expandItem.title}
                              </span>
                            }
                            secondary={expandItem?.dataLabelArray.map(x => {
                              return (
                                <span className="desc">
                                  <span className="text c-orange">
                                    {x?.data}&nbsp;
                                  </span>
                                  <span className="text">
                                    {x?.label}&nbsp;&nbsp;{' '}
                                  </span>
                                </span>
                              )
                            })}
                          />
                          <ListItemSecondaryAction>
                            <IconButton edge="end" aria-label="navigate">
                              <KeyboardArrowRight
                                onClick={() => history.push(expandItem.path)}
                              />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                    </List>
                  </CardExpansion>
                )
              }
              if (
                el?.deployed &&
                handlePermHidden({ permEnum: el?.permission })
              )
                return (
                  <ListItem
                    key={index}
                    onClick={() =>
                      !el?.disabled ? history.push(el?.path) : null
                    }
                    disabled={el?.disabled ? el?.disabled : null}
                  >
                    <IconItem
                      image={el?.icon}
                      imageType="svg"
                      badgeType="default"
                    />
                    <ListItemText
                      style={{
                        textAlign: 'right',
                        marginLeft: '5px',
                      }}
                      primary={
                        DebtorAccountID && el?.title !== 'Debtor Profile' ? (
                          <>
                            <span
                              className="icon-text xsTitle date-width flex-space"
                              style={{ display: 'contents' }}
                            >
                              {el?.title}
                            </span>

                            <span className="c-orange ">
                              <IconText
                                font="xsTitle flex-space"
                                children={amtStr(el?.title2)}
                              ></IconText>
                            </span>
                          </>
                        ) : (
                          <>
                            <span
                              className="icon-text xsTitle date-width flex-space"
                              style={{ display: 'contents' }}
                            >
                              {el?.title}
                            </span>
                          </>
                        )
                      }
                      secondary={
                        <>
                          {el.label1 ? (
                            <span className="desc">
                              <span className="desc">{el.label1}</span>
                              &nbsp;
                              <span className="desc c-orange">{el.data1}</span>
                            </span>
                          ) : (
                            <>
                              <span className="desc">
                                <span className="text c-orange">
                                  {`${el?.draft ?? 0}`}&nbsp;
                                </span>
                                <span className="text">
                                  {`Draft`}&nbsp;&nbsp;{' '}
                                </span>
                                <span className="text c-orange">
                                  {`${el?.submitted ?? 0}`}&nbsp;
                                </span>
                                <span className="text">{`Submitted`}</span>
                              </span>
                            </>
                          )}
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" aria-label="delete">
                        <KeyboardArrowRight
                          onClick={() =>
                            !el?.disabled
                              ? history.push({
                                  pathname: el.path,
                                  state: totalDebtorDocAmt,
                                })
                              : null
                          }
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                )
            })}
        </List>
      </ContentWrapper>
      <SwitchDialog
        open={change}
        onClose={() => setSwitch(false)}
        data={getAssignedCompanyByUser}
        name={'Company'}
        nameID={'CompanyID'}
        currID={homeCompanyID}
        setCurrID={setHomeCompanyID}
        path={`/account-receivable`}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      {/* FOOTER */}
    </>
  )
}
